import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useState } from "react";
import { ActivityIndicator, Text, TouchableOpacity, View } from "react-native";
import RNPickerSelect from "react-native-picker-select";
import InputDefault from "../../components/Form/InputDefault";
import { FormattedMessage } from "react-intl";
import GoBackButton from "../../components/GoBackButton";
import HeaderTabs from "../../components/HeaderTabs";

import HeaderDefault from "../../components/HeaderDefault";
import api from "../../services/api";
import { toast } from "../../utils/toast";

import styles from "./styles";

const EditBankAccount = ({ route, navigation }) => {
  const [bank, setBank] = useState(0);
  const [typeAccount, setTypeAccount] = useState(0);
  const [agency, setAgency] = useState("");
  const [account, setAccount] = useState("");
  const [itemsBanks, setItemsBanks] = useState([]);
  const [accountType, setAccountType] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { item } = route.params;

  useEffect(() => {
    getBanks();
    getAccountType();
    setBank(item.bankId);
    setTypeAccount(item.typeAccountId);
    setAgency(item.agency);
    setAccount(item.account);
  }, []);

  function getBanks() {
    setIsLoading(true);
    api
      .get("/banks")
      .then((res) => {
        var banks = [];

        res.data.data.map((item) => {
          banks.push({
            label: item.bank,
            value: item.id,
          });
        });

        setItemsBanks(banks);
        setIsLoading(false);
      })
      .catch(() => {
        toast(
          intl.formatMessage({ id: "editBankAccount.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  function getAccountType() {
    setIsLoading(true);
    api
      .get("/bank-account-types")
      .then((res) => {
        var types = [];

        res.data.data.map((item) => {
          types.push({
            label: item.name,
            value: item.id,
          });
        });

        setAccountType(types);
        setIsLoading(false);
      })
      .catch(() => {
        toast(
          intl.formatMessage({ id: "editBankAccount.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  async function updateBank() {
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    if (!bank) {
      toast(
        intl.formatMessage({ id: "editBankAccount.selecioneBanco" }),
        "#DA1414"
      );
      return false;
    }

    if (!typeAccount) {
      toast(
        intl.formatMessage({ id: "editBankAccount.selecioneTipoConta" }),
        "#DA1414"
      );
      return false;
    }

    if (!agency) {
      toast(
        intl.formatMessage({ id: "editBankAccount.prenchaNumAgencia" }),
        "#DA1414"
      );
      return false;
    }

    if (!account) {
      toast(
        intl.formatMessage({ id: "editBankAccount.prenchaNumConta" }),
        "#DA1414"
      );
      return false;
    }

    setIsLoading(true);
    const data = {
      bank_id: bank,
      bank_account_type_id: typeAccount,
      branch: agency,
      account: account,
    };

    api
      .put(`/bank-accounts/${item.id}`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        navigation.navigate("BankAccount");
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        toast(
          intl.formatMessage({ id: "editBankAccount.erroCadastro" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="bankAccount.contaBancaria" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="bankAccount.gerencieSuasContas" />
          </Text>
        }
      />

      <View style={styles.container}>
        <View style={{ alignSelf: "flex-start" }}>
          <Text style={styles.titleCard}>
            <FormattedMessage id="editBankAccount.editeSuaConta" />
          </Text>
        </View>

        <View style={{ alignSelf: "flex-start" }}>
          <Text style={{ fontWeight: "bold", marginBottom: 12, marginTop: 6 }}>
            <FormattedMessage id="editBankAccount.Banco" />
          </Text>
        </View>
        <FormattedMessage id="editBankAccount.placeholderSelecioneBanco">
          {(placeholder) => (
            <RNPickerSelect
              onValueChange={(value) => setBank(value)}
              placeholder={{
                label: placeholder,
                value: 0,
              }}
              items={itemsBanks}
              value={bank}
              style={{
                inputWeb: {
                  width: 320,
                  borderRadius: 4,
                  paddingHorizontal: 10,
                  borderColor: "#000000",
                  height: 40,
                  color: "#222",
                  backgroundColor: "#FFFFFF",
                },
              }}
            />
          )}
        </FormattedMessage>

        <View style={{ alignSelf: "flex-start" }}>
          <Text style={{ fontWeight: "bold", marginTop: 12, marginBottom: 6 }}>
            <FormattedMessage id="editBankAccount.tipoConta" />
          </Text>
        </View>

        <FormattedMessage id="editBankAccount.placeholderSelecioneTipoConta">
          {(placeholder) => (
            <RNPickerSelect
              onValueChange={(value) => setTypeAccount(value)}
              placeholder={{
                label: placeholder,
                value: 0,
              }}
              items={accountType}
              value={typeAccount}
              style={{
                inputWeb: {
                  width: 320,
                  borderRadius: 4,
                  paddingHorizontal: 10,
                  borderColor: "#000000",
                  height: 40,
                  color: "#222",
                  backgroundColor: "#FFFFFF",
                },
              }}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="editBankAccount.placeholderAgencia">
          {(placeholder) => (
            <View style={{}}>
              <InputDefault
                value={agency}
                onValueChange={(value) => setAgency(value)}
                placeholder={placeholder}
              />
            </View>
          )}
        </FormattedMessage>

        <FormattedMessage id="editBankAccount.placeholderConta">
          {(placeholder) => (
            <View style={{}}>
              <InputDefault
                value={account}
                onValueChange={(value) => setAccount(value)}
                placeholder={placeholder}
              />
            </View>
          )}
        </FormattedMessage>
        <View style={styles.contentBtn}>
          <TouchableOpacity
            onPress={updateBank}
            disabled={isLoading ? true : false}
            style={styles.btn}
          >
            {isLoading ? (
              <ActivityIndicator color="#2797A2" size="small" />
            ) : (
              <Text style={styles.textBtn}>
                <FormattedMessage id="editBankAccount.btnSalvar" />
              </Text>
            )}
          </TouchableOpacity>
        </View>
      </View>
    </>
  );
};

export default EditBankAccount;
